<script setup>
import ModalFrame from "@/Components/Misc/ModalFrame.vue";
</script>

<template>
	<ModalFrame @hide="hide()">

		<template #header>
			{{ $store.state.central.modal.title }}
		</template>

		<div class="pb-4 d-flex flex-column align-items-center" v-html="$store.state.central.modal.content"></div>

	</ModalFrame>
</template>

<script>
export default {
	name: "ConfirmationModal",
	methods: {
		hide() {
			this.$store.dispatch('central/destroyModal')
		}
	}
}
</script>

<style scoped>

</style>